export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm2.757 14.17a5.004 5.004 0 01-5.515 0l-2.147 2.147A7.963 7.963 0 0012 20c1.849 0 3.549-.63 4.903-1.683l-2.146-2.146zM5.682 7.097A7.963 7.963 0 004 12c0 1.848.629 3.549 1.682 4.903l2.146-2.146a5.005 5.005 0 010-5.515L5.682 7.096zM16.17 9.242a5.004 5.004 0 010 5.515l2.146 2.146A7.962 7.962 0 0020 12c0-1.85-.63-3.55-1.683-4.905l-2.146 2.147zm-2.05.637A3 3 0 109.88 14.12 3 3 0 0014.12 9.88zM12 4c-1.849 0-3.55.629-4.904 1.682l2.146 2.146a5.005 5.005 0 015.515 0l2.146-2.146A7.962 7.962 0 0012 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};